import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Bookmark: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.99994 0.996V1.992H12.9959H19.9919V10.992V19.992H20.9999H22.0079V9.996V0H14.0039H5.99994V0.996ZM1.99194 14.004C1.99194 19.5018 1.99612 24 2.00121 24C2.00632 24 3.75863 22.9436 5.89521 21.6524C8.03181 20.3613 9.83025 19.2754 9.89171 19.2395L10.0035 19.1741L13.9237 21.5432C16.0798 22.8463 17.879 23.9332 17.9219 23.9586L17.9999 24.0048V14.0064V4.008H9.99594H1.99194V14.004ZM4.00794 13.2254C4.00794 18.9998 4.01397 20.4471 4.03794 20.432C4.42012 20.1923 9.97917 16.8418 9.99594 16.8411C10.0091 16.8405 11.3633 17.6519 13.0051 18.644C14.647 19.6362 15.9943 20.448 15.9991 20.448C16.004 20.448 16.0079 17.1972 16.0079 13.224V6H10.0079H4.00794V13.2254Z'
        fill={fill}
      />
    </svg>
  )
}

export default Bookmark
